import React from "react";
import firebaseManager from "../../../../model/Firebase/FirebaseManager";

class EditDataUser extends React.Component {
  constructor() {
    super();
    this.updateInfoTechnician = this.updateInfoTechnician.bind(this);
    this.handleChangeFullName = this.handleChangeFullName.bind(this);
    this.handleChangeAddress = this.handleChangeAddress.bind(this);
    this.handleChangePhoneNumber = this.handleChangePhoneNumber.bind(this);
    this.state = {
      fullName: "",
      address: "",
      phoneNumber: "",
    };
    this.getDentuser();
  }

  getDentuser() {
    firebaseManager.getInfoForCurrentTechnician(this.getUsersCallback);
  }

  getUsersCallback = (userProfileData) => {
    this.setState({
      fullName: userProfileData.name,
      phoneNumber: userProfileData.phoneNumber,
      address: userProfileData.address,
    });
  };

  updateInfoTechnician(e) {
    e.preventDefault();
    firebaseManager.updateInfoCurrentUser(
      this.state.fullName,
      this.state.address,
      this.state.phoneNumber,
      this.handleSuccess,
      this.handleFailError
    );
  }

  handleSuccess() {
    window.location = "/profile";
  }

  handleFailError(error) {
    alert(error.message);
  }

  handleChangeFullName = (e) => {
    this.setState({
      fullName: e.target.value,
      address: this.state.address,
      phoneNumber: this.state.phoneNumber,
    });
  };

  handleChangeAddress = (e) => {
    this.setState({
      address: e.target.value,
      fullName: this.state.fullName,
      phoneNumber: this.state.phoneNumber,
    });
  };

  handleChangePhoneNumber = (e) => {
    this.setState({
      address: this.state.address,
      fullName: this.state.fullName,
      phoneNumber: e.target.value,
    });
  };

  render() {
    return (
      <div className="container mt-2">
        <form>
          <div className="form-group">
            <input
              onChange={this.handleChangeFullName}
              value={this.state.fullName}
              id="fullName"
              name="fullName"
              type="text"
              placeholder="First Name"
              className="size"
            />
          </div>
          <div className="form-group">
            <input
              onChange={this.handleChangePhoneNumber}
              value={this.state.phoneNumber}
              id="phoneNumber"
              name="phoneNumber"
              type="number"
              placeholder="Phone Number"
              className="size"
            />
          </div>
          <div className="form-group">
            <input
              onChange={this.handleChangeAddress}
              value={this.state.address}
              name="address"
              id="address"
              type="text"
              placeholder="Address"
              className="size"
            />
          </div>
          <button
            type="submit"
            onClick={this.updateInfoTechnician}
            className="btn btn-secondary mb-5 mx-auto"
          >
            Save
          </button>
        </form>
      </div>
    );
  }
}
export default EditDataUser;
